import { ContentApi } from '@app/services/apiServices/ContentApi';
import { Component, Inject, OnInit } from "@angular/core";
import { take } from "rxjs/operators";

@Component({
    selector: 'app-terms',
    template: require('./termsAndConditions.html'),
})
export class TermsAndConditionsComponent implements OnInit{
    terms: string;

    constructor(@Inject(ContentApi) private contentApi: ContentApi) { }

    ngOnInit() {
        this.contentApi.fetchGlobalContentByLocationType('pptos')
            .pipe(take(1)).subscribe({
                next: resp => {
                    this.terms = decodeURIComponent(resp.msg);
                },
                error: () => {
                }
            });
    }
}
